export const markdown_faq_7_1 = `Per ricercare un ponte vai nella sezione **PONTI**:

**Posizione sulla mappa**: potrai trovarlo direttamente sulla mappa se ne ricordi la posizione.

**Filtri**: puoi usare i filtri, di base o avanzati, per restringere sempre più il campo di ricerca. `;
export const markdown_faq_7_2 = `I ponti ricercati saranno visibili nella mappa e nelle card sottostanti, dove sono riassunte le informazioni base e l'immagine di copertina.`;
